import { createAction, props } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { CustomerApiModel } from 'app/models/customer-api.model';

export const loadCustomers = createAction(
  '[Customers] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadCustomersSuccess = createAction(
  '[Customers] Load Successful',
  props<{ response: MwPayloadModel<CustomerApiModel[]> }>()
);

export const loadCustomersFailed = createAction(
  '[Customers] Load Failed',
  props<{ error: any }>()
);

export const createCustomer = createAction(
  '[Customers] Create',
  props<{ customer: CustomerApiModel }>()
);

export const createCustomerSuccess = createAction(
  '[Customers] Create Successful'
);

export const createCustomerFailed = createAction(
  '[Customers] Create Failed',
  props<{ error: any }>()
);

export const updateCustomer = createAction(
  '[Customers] Update',
  props<{ customer: CustomerApiModel }>()
);

export const updateCustomerSuccess = createAction(
  '[Customers] Update Successful'
);

export const updateCustomerFailed = createAction(
  '[Customers] Update Failed',
  props<{ error: any }>()
);

export const deleteCustomer = createAction(
  '[Customers] Delete',
  props<{ customer: CustomerApiModel }>()
);

export const deleteCustomerSuccess = createAction(
  '[Customers] Delete Successful'
);

export const deleteCustomerFailed = createAction(
  '[Customers] Delete Failed',
  props<{ error: any }>()
);

export const resetCustomers = createAction('[Customers] Reset');
